import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import * as React from "react";
import styled from "styled-components";
import { NewsModule } from "@faire/retailer/components/NewsModule/NewsModule";
export var NewsSection = function() {
    var isMobile = useViewport().isMobile;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: isMobile ? 0 : "2x"
            }),
            /*#__PURE__*/ _jsx(CenteredNews, {
                eventPrefix: "faire-direct-sign-up/landing-page/news/"
            })
        ]
    });
};
var CenteredNews = styled(NewsModule).withConfig({
    componentId: "sc-9f8a204b-0"
})([
    "margin:0 auto;"
]);
